module.exports = __webpack_public_path__ + "static/img/bg2.ec6414e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bg2.jpg
// module id = 122
// module chunks = 1